import axios from 'axios';

const baseUrl = `${process.env.NODE_ENV === 'production' ? process.env.REACT_APP_OCS_API : process.env.REACT_APP_OCS_API_DEV}api/`;

export default axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    type: 'cors'
  }
});
